// extracted by mini-css-extract-plugin
module.exports = {"pane":"SlidingPane_pane__3zyUz","back":"SlidingPane_back__37TEJ","arrow":"SlidingPane_arrow__cboCF"};